import { render, staticRenderFns } from "./WidgetVisibilityManager.vue?vue&type=template&id=2d05f182&lang=pug&"
import script from "./WidgetVisibilityManager.vue?vue&type=script&lang=js&"
export * from "./WidgetVisibilityManager.vue?vue&type=script&lang=js&"
import style0 from "./WidgetVisibilityManager.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d05f182')) {
      api.createRecord('2d05f182', component.options)
    } else {
      api.reload('2d05f182', component.options)
    }
    module.hot.accept("./WidgetVisibilityManager.vue?vue&type=template&id=2d05f182&lang=pug&", function () {
      api.rerender('2d05f182', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inspector/specific/WidgetVisibilityManager.vue"
export default component.exports